import {AbstractControl, ValidatorFn} from '@angular/forms';

import {OnlyCyrillicValidatorKey} from './custom-validator-keys';

export function OnlyCyrillicValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[\u0400-\u04FF0-9№\.\,\s]+$/.test(controlValue) ? {[OnlyCyrillicValidatorKey]: true} : null;
    };
}
